import { IFilterProductPrice } from '@type/productPrice';
import { qdfoodApi } from './constant';
import { IResponse } from '@type/response';
import { IFilter } from '@type/param';
import { IProductCustomProposalPrice } from '@features/profile/ProductPriceProposalTable';

const PRODUCT_PRICE_PROPOSAL_URL = {
  urlGetList: (userId: string) => `/product-price-proposal/${userId}/web-user`,
};

export default class productPriceProposalApi {
  static getListPagination = (userId: string, params: IFilter<IFilterProductPrice>) =>
    qdfoodApi().get<IResponse<IProductCustomProposalPrice>>(
      PRODUCT_PRICE_PROPOSAL_URL.urlGetList(userId),
      {
        params,
      }
    );
}
